import React from "react";
import exclamation from "../../../assets/img/exclamation.png";
import budget from "../../../assets/img/budget.png";

const Title = ({
  marginHeader,
  className,
  projectTitle,
  required,
  subTitle,
  isDelete,
  fontSizeList,
  maxWidthwidth,
  isObjectif,
  fontSizeUpdate,
}) => {
  return (
    <div
      className={`${className} project-title`}
      style={{ marginLeft: marginHeader, maxWidth: maxWidthwidth }}
    >
      {isObjectif ? (
        <div className="objective-wrapper">
          <img src={budget} alt="objective-icon" />
          <h4 style={{ fontSize: fontSizeUpdate }}>{projectTitle}</h4>
        </div>
      ) : (
        <h4 className={isDelete ? "delete-h4" : ""}>{projectTitle}</h4>
      )}
      {required ? (
        <span>
          {/* {!isObjectif && subTitle !== "" && "* champs obligatoires"} */}
          <br /> {subTitle}
        </span>
      ) : isDelete ? (
        <div className="element-centred">
          <img
            src={exclamation}
            alt="exclamation"
            style={{ marginRight: "11px" }}
          />
          <span id="confirm-delete">{subTitle}</span>
        </div>
      ) : (
        <span style={{ fontSize: fontSizeList }}> {subTitle} </span>
      )}
    </div>
  );
};

export default Title;
